import { render, staticRenderFns } from "./orderLsList.vue?vue&type=template&id=1fa4a542"
import script from "./orderLsList.vue?vue&type=script&lang=js"
export * from "./orderLsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports